// extracted by mini-css-extract-plugin
export default {"Underlined":"NiqRJkm4"};